<template>
  <div
    class="
      z-50
      fixed
      inset-0
      flex
      items-start
      justify-end
      px-4
      py-6
      sm:p-6
      pointer-events-none
    "
  >
    <div class="max-w-sm w-full">
      <transition-group
        tag="div"
        :enter-active-class="
          sortedNotifications.length > 1
            ? 'transform ease-out delay-300 duration-300 transition'
            : 'transform ease-out duration-300 transition'
        "
        enter-class="translate-x-4 opacity-0"
        enter-to-class="translate-x-0 opacity-100"
        leave-active-class="transition ease-in duration-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
        move-class="transition ease-in-out duration-500"
      >
        <Notification
          v-for="(notification, i) in sortedNotifications"
          :key="notification.id"
          :notification="notification"
          :class="i > 0 ? 'mt-4' : ''"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Notification from '@/components/Notification'

export default {
  components: {
    Notification,
  },

  computed: {
    notifications() {
      return this.$store.state.notification.notifications
    },

    sortedNotifications() {
      return [...this.notifications].reverse().slice(0, 4)
    },
  },
}
</script>
